import { Loader } from 'components'
import styles from './AttachmentsLoader.module.scss'

interface Props {
    showLoader: boolean
}

const AttachmentsLoader = ({ showLoader }: Props) => {
    return (
        <>
            {showLoader ? (
                <div className={styles.wrapper}>
                    <div className={styles.innerWrapper}>
                        <div>
                            <Loader
                                size={24}
                                className={styles.loader}
                                loaderType="clip"
                                fullHeight={false}
                                color="#1D65A1"
                            />
                        </div>

                        <p>Wait please, uploading attachments...</p>
                    </div>
                </div>
            ) : null}
        </>
    )
}

export default AttachmentsLoader
